import {
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import {
	MatFormField,
	MatPrefix,
	MatLabel,
	MatInput,
	MatError,
} from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
	selector: 'formly-currency-input',
	template: `
		<mat-form-field
			appearance="outline"
			style="width: 100%"
			[subscriptSizing]="props['subscriptSizing'] || 'dynamic'"
			[floatLabel]="props['floatLabel'] || 'auto'"
		>
			<span matTextPrefix matInput class="{{ props.disabled ? 'disable' : '' }}"
				>$</span
			>
			<mat-label>{{ props.label }}</mat-label>
			<input
				matInput
				[formControl]="formControl"
				[formlyAttributes]="field"
				[required]="props.required"
				[readonly]="props.readonly"
				mask="separator.2"
				thousandSeparator=","
				decimalMarker="."
				[placeholder]="props.placeholder || ''"
			/>
			<mat-error *ngIf="formControl.invalid && formControl.touched">
				<formly-validation-message [field]="field"></formly-validation-message>
			</mat-error>
		</mat-form-field>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./currency-input.type.scss'],
	imports: [
		MatFormField,
		MatPrefix,
		MatLabel,
		MatInput,
		NgxMaskDirective,
		ReactiveFormsModule,
		FormlyModule,
		NgIf,
		MatError,
	],
})
export class CurrencyInputType
	extends FieldType<FieldTypeConfig>
	implements OnInit, OnDestroy
{
	private valueSub?: Subscription;

	constructor(private readonly cdr: ChangeDetectorRef) {
		super();
	}

	ngOnInit(): void {
		// ngx-mask writes the input asynchronously, after this OnPush view was checked, so a
		// value set from code leaves the label down until the next interaction. Re-check once
		// the mask has written it.
		this.valueSub = this.formControl.valueChanges.subscribe(() =>
			setTimeout(() => this.cdr.markForCheck())
		);
	}

	ngOnDestroy(): void {
		this.valueSub?.unsubscribe();
	}
}
